import AccountVerification from './AccountVerification';

export default AccountVerification;